import React from "react";
import useCompositionBoard from "../../../hooks/useCompositionBoard";
import "./CompositionBoard.scss";
import chairmanImage from "../../../assets/About/chairman.png";
import ceoImg from "../../../assets/About/rupali-ceo.png";
import boardImg from "../../../assets/board-bg.png";

const CompositionBoard = () => {
  const [boardInfo, setBoardInfo, loading] = useCompositionBoard();

  // console.log("boardInfo", boardInfo);

  const chairman = boardInfo.filter((person) => person.Type === "Chairman");
  const ceo = boardInfo.filter(
    (person) => person.Type === "Chief Executive Officer"
  );
  const audit = boardInfo.filter((person) => person.Type === "Audit Committee");
  const nrc = boardInfo.filter((person) => person.Type === "NRC Committee");
  const director = boardInfo.filter((person) => person.Type === "Directors");

  const investment = boardInfo.filter(
    (person) => person.Type === "Investment Committee"
  );
  const riskManagement = boardInfo.filter(
    (person) => person.Type === "Risk Management Committee"
  );
  const policyholderProtectionCompliance = boardInfo.filter(
    (person) => person.Type === "Policyholder Protection & Compliance Committee"
  );

  // console.log(
  //   "investment",
  //   investment,
  //   riskManagement,
  //   policyholderProtectionCompliance
  // );

  return (
    <>
      <div className="composition_board">
        <div
          className="composition_board_bg"
          style={{ backgroundImage: `url(${boardImg})` }}
          data-aos="zoom-in"
        ></div>

        <div className="container-fluid p-0">
          <div className="heading_box">Composition of Board & Committee</div>

          <div className="board_content">
            <div className="container">
              <div className="chairman_content">
                <div className="row justify-content-between">
                  <div className="col-lg-6 left">
                    {loading ? (
                      <>
                        {chairman.map((board, index) => (
                          <div key={index}>
                            <h4>{board.Title}</h4>
                            <h5>{board.Name}</h5>

                            <p className="">
                              Currently, Mostafa Golam Quddus holds the position
                              of Chairman of Rupali Insurance Co. Ltd. <br /> In
                              his past career Mr. Quddus held the position of
                              President for Bangladesh Garment Manufacturers &
                              Exporters Association.
                            </p>
                          </div>
                        ))}
                      </>
                    ) : (
                      <div className="text-center my-5">
                        <button className="btn btn-danger w-50" type="button">
                          <span
                            className="spinner-border spinner-border-sm"
                            role="status"
                            aria-hidden="true"
                          ></span>
                          Loading...
                        </button>
                      </div>
                    )}
                  </div>

                  <div className="col-lg-5 my-auto order-first order-lg-last">
                    <div className="right">
                      <div className="chairman_content_box">
                        <div className="line_rotate"></div>
                        <div className="chairman_img">
                          <img
                            src={chairmanImage}
                            className="img-fluid"
                            alt=""
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div className="others_content">
              <div className="container">
                <div className="ceo_content_box">
                  <div className="row justify-content-between">
                    <div className="col-lg-5 mb-lg-0 mb-5">
                      <div className="ceo_left">
                        <img
                          src={ceoImg}
                          className="img-fluid ceo_img"
                          alt=""
                        />
                        <h5>{ceo[0]?.Name}</h5>
                        <h6>{ceo[0]?.Title} (C.C)</h6>
                      </div>
                    </div>
                    <div className="col-lg-6 my-auto">
                      {loading ? (
                        <div className="ceo_right">
                          <div className="ceo_content">
                            {ceo.map((board, index) => (
                              <div key={index}>
                                <h4>{board.Title} (C.C)</h4>
                                <h5
                                  style={{
                                    color: "#cf173c",
                                    fontFamily: "Inter",
                                    textTransform: "uppercase",
                                  }}
                                >
                                  <b>{board.Name}</b>
                                </h5>

                                <p>
                                  Fauzia Quamrun Tania is the Chief Executive
                                  Officer of the Company. She has completed BSc
                                  (Hon’s) MA in Business Management and Applied
                                  Mathematics from University of Glasgow, UK.
                                  Fauzia has significant experience in the field
                                  of Insurance as she holds Directorship at
                                  Sonali Life Insurance Company Limited.
                                  Fauzia's tenure at Ruplai Insurance Company
                                  Limited makes her well placed to determine the
                                  nature and extent of the scope required for
                                  Rupali Insurance to achieve it's strategic
                                  objectives and develop digital businesses and
                                  improve the corporate culture of the Company.
                                  She has traveled many countries in Europe,
                                  Asia and Australia and therefore can
                                  contribute of the necessary adaptations
                                  required to maintain Global standard.
                                </p>
                              </div>
                            ))}
                          </div>
                        </div>
                      ) : (
                        <div className="text-center my-5">
                          <button className="btn btn-danger w-50" type="button">
                            <span
                              className="spinner-border spinner-border-sm"
                              role="status"
                              aria-hidden="true"
                            ></span>
                            Loading...
                          </button>
                        </div>
                      )}
                    </div>
                  </div>
                </div>

                <div className="row">
                  <div className="col-lg-6 ">
                    <div className="left">
                      {/* <div className="ceo_content">
                        {ceo.map((board, index) => (
                          <div key={index}>
                            <h4>{board.Title}</h4>
                            <h5
                              style={{ color: "#cf173c", fontFamily: "Inter" }}
                            >
                              <b>{board.Name}</b>
                            </h5>
                          </div>
                        ))}
                      </div> */}
                      <div className="director_content">
                        <h4>Directors</h4>
                        {director.map((board, index) => (
                          <div key={index} className="row">
                            <div className="col-8">
                              <p>
                                <b>{board.Name}</b>
                              </p>
                            </div>
                            <div className="col-4">
                              <p>{board.Title}</p>
                            </div>
                          </div>
                        ))}
                      </div>
                    </div>
                  </div>

                  <div className="col-lg-6 my-5 my-lg-0">
                    <div className="right">
                      <div className="audit_content committee_content">
                        <h4>Audit Committee</h4>
                        {audit.map((board, index) => (
                          <div key={index} className="row">
                            <div className="col-8">
                              <p>
                                <b>{board.Name}</b>
                              </p>
                            </div>
                            <div className="col-4">
                              <p>{board.Title}</p>
                            </div>
                          </div>
                        ))}
                      </div>

                      <div className="nrc_content committee_content">
                        <h4>NRC Committee</h4>
                        {nrc.map((board, index) => (
                          <div key={index} className="row">
                            <div className="col-8">
                              <p>
                                <b>{board.Name}</b>
                              </p>
                            </div>
                            <div className="col-4">
                              <p>{board.Title}</p>
                            </div>
                          </div>
                        ))}
                      </div>

                      <div className="committee_content">
                        <h4>Investment Committee</h4>
                        {investment.map((board, index) => (
                          <div key={index} className="row">
                            <div className="col-8">
                              <p>
                                <b>{board.Name}</b>
                              </p>
                            </div>
                            <div className="col-4">
                              <p>{board.Title}</p>
                            </div>
                          </div>
                        ))}
                      </div>

                      <div className="committee_content">
                        <h4>Risk Management Committee</h4>
                        {riskManagement.map((board, index) => (
                          <div key={index} className="row">
                            <div className="col-8">
                              <p>
                                <b>{board.Name}</b>
                              </p>
                            </div>
                            <div className="col-4">
                              <p>{board.Title}</p>
                            </div>
                          </div>
                        ))}
                      </div>

                      <div className="committee_content">
                        <h4>Policyholder Protection & Compliance Committee</h4>
                        {policyholderProtectionCompliance.map(
                          (board, index) => (
                            <div key={index} className="row">
                              <div className="col-8">
                                <p>
                                  <b>{board.Name}</b>
                                </p>
                              </div>
                              <div className="col-4">
                                <p>{board.Title}</p>
                              </div>
                            </div>
                          )
                        )}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default CompositionBoard;
